// ─────────────────────────────────────────────────────────────────────────────
// DOC-LIFECYCLE-001 (Phase D) — PURE Logik der Admin-Review-Inbox (kein React, kein Netz).
// Spiegelt bewusst die Backend-Regeln (lib/reviewNotify.js):
//   • Bereich: Selfie eigener Zähler; Fahrzeugdokumente NUR im Fahrzeugbereich.
//   • Badge sinkt ERST nach ERFOLGREICHER Entscheidung (removeDecided*), nie beim Ansehen.
//   • Beim Selfie-Event ist document_id die VERIFIZIERUNGS-ID (Vertrag Stufe C).
// Getestet in admin-app/scripts/tests/review-logic.test.mjs (node --test).
// R1 (P1-A): document_id/verification_id/Event-id sind UUIDv4- ODER Legacy-Strings →
// Vergleich IMMER als String (sameId), nie Number() (UUID → NaN → Dubletten/Leaks).
// ─────────────────────────────────────────────────────────────────────────────
import { sameId } from './idUtil.mjs';

// Bereich eines Inbox-Events (identisch zur Server-Regel).
export function bereichOf(ev) {
  if (!ev) return 'fahrer';
  if (ev.kind === 'selfie') return 'selfie';
  if (ev.owner_type === 'vehicle') return 'fahrzeug';
  if (ev.owner_type === 'partner') return 'partner';
  return 'fahrer';
}

// Badges je Bereich aus den ungelesenen Events; Selfies zählen im Gesamtzähler mit.
export function computeBadges(events) {
  const badges = { fahrer: 0, partner: 0, fahrzeug: 0, selfie: 0, total: 0 };
  for (const ev of events || []) { badges[bereichOf(ev)] += 1; badges.total += 1; }
  return badges;
}

// Erfolgreiche DOKUMENT-Entscheidung → genau die Dokument-Events dieser ID räumen.
// Selfie-Events bleiben unberührt (dort ist document_id die Verifizierungs-ID).
export function removeDecidedDocument(events, documentId) {
  const list = events || [];
  const next = list.filter((e) => !(e.kind !== 'selfie' && sameId(e.document_id, documentId)));
  return next.length === list.length ? list : next;
}

// Erfolgreiche SELFIE-Entscheidung → genau das Selfie-Event dieser Verifizierung räumen.
export function removeDecidedSelfie(events, verificationId) {
  const list = events || [];
  const next = list.filter((e) => !(e.kind === 'selfie' && sameId(e.document_id, verificationId)));
  return next.length === list.length ? list : next;
}

// Socket-Event einsortieren: neuestes vorne, Dubletten (gleiche id) idempotent.
export function mergeInboxEvent(events, ev) {
  const list = events || [];
  if (!ev || list.some((e) => sameId(e.id, ev.id))) return list;
  return [ev, ...list];
}

// kind-Feld sichtbar unterscheiden (Erstupload/Reupload/Erneuerung/Selfie).
const KIND_LABELS = { erstupload: 'Erstupload', reupload: 'Reupload', renewal: 'Erneuerung', selfie: 'Selfie' };
export function kindLabel(kind) { return KIND_LABELS[kind] || kind || '–'; }

// Deep-Link je Event: Selfie → Vergleichsseite; Dokument → Drawer (zeigt Owner+Revision).
export function deepLinkForEvent(ev) {
  if (!ev) return '/documents';
  if (ev.kind === 'selfie') return `/verifications/${ev.document_id}`;
  return `/documents?doc=${ev.document_id}`;
}

// Dashboard-/Nav-Link in die richtige Queue je Bereich.
const QUEUE_LINKS = {
  fahrer: '/documents?status=pending&owner_type=driver',
  partner: '/documents?status=pending&owner_type=partner',
  fahrzeug: '/documents?status=pending&owner_type=vehicle',
  selfie: '/verifications',
};
export function queueLinkForBereich(bereich) { return QUEUE_LINKS[bereich] || '/documents'; }

// Bereichs-Label für Anzeige.
const BEREICH_LABELS = { fahrer: 'Fahrer', partner: 'Partner', fahrzeug: 'Fahrzeug', selfie: 'Selfie' };
export function bereichLabel(bereich) { return BEREICH_LABELS[bereich] || bereich; }
